import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { container } from '@infrastructure/container';

interface AuthState {
  userId: string | null;
  companyId: string | null;
  jwt: string | null;
  setAuth: (userId: string, jwt: string, companyId?: string) => void;
  clearAuth: () => Promise<void>;
  isJwtValid: (jwt: string) => boolean;
  getJwt: () => Promise<string | null>;
  refreshJwt: () => Promise<string | null>;
}

export const useAuthStore = create(
  persist<AuthState>(
    (set, get) => ({
      userId: null,
      companyId: null,
      jwt: null,

      setAuth: (userId, jwt, companyId) =>
        set({ userId, jwt, companyId }),

      clearAuth: async () => {
        set({ userId: null, companyId: null, jwt: null });
      },


      isJwtValid: (jwt: string): boolean => {
        const parts = jwt.split('.');

        if (parts.length !== 3) {
          return false;
        }

        try {
          const payload = JSON.parse(
            atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
          );

          const exp = payload.exp;
          if (!exp) {
            return false;
          }

          const now = Math.floor(Date.now() / 1000);
          return exp > now;
        } catch (e) {
          return false;
        }
      },

      getJwt: async () => {
        const jwt = get().jwt;

        if (!jwt || !get().isJwtValid(jwt)) {
          const refreshed = await get().refreshJwt();
          if (!refreshed) {
            await get().clearAuth();
          }
          return refreshed;
        }

        return jwt;
      },

      refreshJwt: async () => {
        const jwtResponse = await container.authRepository.createJwt();
        if (jwtResponse.status === 'error' || !jwtResponse.data) {
          return null;
        }
        set({ jwt: jwtResponse.data });
        return jwtResponse.data;
      },

    }),
    {
      name: 'auth-storage',
    }
  )
);